import type { ShiftProductionRate } from "./machine-production-rate.model";

export type ShiftID = "A" | "B";
export type GroupID = "A" | "B" | "C" | "D";

// Mirrors Sierra.Production.Models.Enum.Shift (order = numeric enum value)
export const SHIFT_VALUES = ["A", "B", "C"] as const;

export function mapShift(raw: number | string | null | undefined): ShiftID {
  if (raw === null || raw === undefined) return "A";
  const name = typeof raw === "number" ? SHIFT_VALUES[raw] : raw;
  return name === "A" || name === "B" ? name : "A";
}

// Honduras runs UTC-6 with two 12-hour shifts: A = 07:00–19:00, B = 19:00–07:00.
// The kiosk's local clock is authoritative — backend may run in a different tz.
export function getCurrentShiftFromLocalTime(now: Date = new Date()): ShiftID {
  const hour = now.getHours();
  return hour >= 7 && hour < 19 ? "A" : "B";
}

export interface Client {
  name: string;
  brandName: string;
  lbs: string;
}

export interface WorkOrderProgress {
  workOrderNumber: string;
  requiredLbs: string;
  progress: string;
}

export interface KnittingOrder {
  knittingOrderNumber: string;
  progress: number;
  currentLbs: string;
  totalLbs: string;
}

export interface RejectedOrder {
  knittingOrderNumber: string;
  rejectionRate: number;
  rejectedLbs: string;
  totalLbs: string;
}

export interface RejectedMachine {
  machineCode: string;
  rejectionRate: number;
  rejectedLbs: string;
  totalLbs: string;
}

export interface PerformanceMetrics {
  productionThisMonth: number;
  productionLastMonth: number;
  machineEfficiency: number;
  machineEfficiencyLastMonth: number;
  qualityRejectionRate: number;
  qualityRejectionRateLastMonth: number;
}

export interface DashboardData {
  shift: ShiftID;
  clients: Client[];
  workOrders: WorkOrderProgress[];
  knittingOrders: KnittingOrder[];
  closedKnittingOrders: KnittingOrder[];
  rejectedOrders: RejectedOrder[];
  rejectedMachines: RejectedMachine[];
  performanceMetrics?: PerformanceMetrics;
  machineProductionRates?: ShiftProductionRate;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
}
